<template>
	<div class="mobile-hide shadow-1" color="white">
		<div class="row q-py-md q-px-md fit justify-center">
			<div class="col-sm-12">
				<div class="row">
					<div class="col-2">
						<img :src="logo" height="auto" style="max-width: 100%;" />
					</div>

					<div class="col-10 text-right self-center">
						<span v-for="(button, index) in getNavbarOrder" :key="index">
							<q-btn
								flat
								size="lg"
								:color="button.to == $route.meta.title ? 'primary' : 'secondary'"
								:label="$t(button.text)"
								@click="$router.push({ name: button.to })"
								v-if="button.to"
							/>

							<q-btn-dropdown
								flat
								size="lg"
								:label="button.text"
								v-if="!button.to && button.buttons.length > 0"
								:color="getColorButtonMerged"
							>
								<q-list>
									<q-item
										link
										v-for="(b, index) in button.buttons"
										:key="`b-${index}`"
										:to="{ name: b.to }"
									>
										<q-item-main>
											<q-item-tile label>{{ $t(b.text) }}</q-item-tile>
										</q-item-main>
									</q-item>
								</q-list>
							</q-btn-dropdown>
						</span>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
	i18nOptions: { namespaces: ['custom', 'common', 'authenticated'] },

	data() {
		return {
			logo: '',
			show_merged: false,
		}
	},

	computed: {
		...mapGetters({
			clients: 'params/clients',
			params_loaded: 'params/params_loaded',
			id_user_client_selected: 'common/id_user_client_selected',
		}),

		getNavbarOrder() {
			let navbar = []

			if (this.id_user_client_selected) {
				let obj = this.clients.find((obj) => {
					return obj.id === this.id_user_client_selected
				})
				if (obj) {
					if (obj.has_home) {
						navbar.push({
							icon: 'far fa-home',
							to: 'home',
							text: obj.title_home == '' ? 'home' : obj.title_home,
						})
					}

					if (obj.has_feed) {
						navbar.push({
							icon: 'far fa-comment-alt-smile',
							to: 'feed',
							text: obj.title_feed == '' ? 'feed' : obj.title_feed,
						})
					}

					if (obj.has_faq) {
						navbar.push({
							icon: 'far fa-question-square',
							to: 'faq',
							text: obj.title_faq == '' ? 'faq' : obj.title_faq,
						})
					}

					if (obj.has_profile) {
						navbar.push({
							icon: 'far fa-user',
							to: 'profile',
							text: obj.title_profile == '' ? 'profile' : obj.title_profile,
						})
					}
				}

				let index = navbar.findIndex((x) => x.to === obj.home_route)
				if (index && index != 0) {
					navbar.unshift(
						navbar.splice(navbar.findIndex((item) => item.to === obj.home_route), 1)[0]
					)
				}
			}

			return navbar
		},

		getColorButtonMerged() {
			let routes = ['courses', 'trails', 'webcasts', 'presential', 'podcasts']

			if (routes.includes(this.$route.meta.title)) return 'primary'
			else return 'secondary'
		},
	},

	methods: {
		changeLogo() {
			let client = this.clients.find((obj) => {
				return obj.id === this.id_user_client_selected
			})

			if (client) {
				this.logo = client.logo
			}
		},
	},

	watch: {
		params_loaded: function() {
			this.changeLogo()
		},

		id_user_client_selected: function() {
			this.changeLogo()
		},
	},

	mounted() {
		if (this.clients) {
			this.changeLogo()
		}
	},
}
</script>

<style></style>
